module.exports = __webpack_public_path__ + "static/media/dashboard-earn.4dba4a94.png";